var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupbutton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 56,
    viewBox: "0 0 212 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_4112)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 56,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 50,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 50)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 56,
    width: 6,
    height: 6,
    transform: "rotate(-90 6 56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 56,
    width: 6,
    height: 6,
    transform: "rotate(-90 194 56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 50,
    width: 6,
    height: 6,
    transform: "rotate(-90 200 50)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 206 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-90 200 12)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 56,
    width: 6,
    height: 6,
    transform: "rotate(-90 206 56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.32 36.216C64.24 36.216 62.296 34.128 62.2 30.96H64.336C64.456 33 65.68 34.272 68.32 34.272C70.768 34.272 72.184 33.312 72.184 31.392C72.184 29.76 71.248 29.04 69.424 28.656L66.976 28.128C64.312 27.552 62.776 26.16 62.776 23.592C62.776 20.88 64.864 18.984 68.344 18.984C71.704 18.984 74.056 21 74.08 23.976H71.944C71.848 22.152 70.648 20.952 68.296 20.952C66.304 20.952 64.936 21.816 64.936 23.592C64.936 24.96 65.776 25.68 67.552 26.088L69.832 26.616C72.712 27.288 74.368 28.632 74.368 31.392C74.368 34.392 71.968 36.216 68.32 36.216ZM75.9353 36V34.008H79.4393V21.192H75.9353V19.2H85.1033V21.192H81.5993V34.008H85.1033V36H75.9353ZM93.4184 36.216C89.1944 36.216 86.7944 33.624 86.7944 29.04V26.16C86.7944 21.576 89.1944 18.984 93.4184 18.984C97.4264 18.984 99.6584 21.36 99.9464 25.032H97.7624C97.4984 22.704 96.3704 21.024 93.4184 21.024C90.1784 21.024 88.9544 23.016 88.9544 26.16V29.04C88.9544 32.184 90.1784 34.176 93.4184 34.176C96.0584 34.176 97.8344 32.952 97.8344 28.968V28.848H93.3944V26.928H99.9944V28.848C99.9944 33.216 97.9304 36.216 93.4184 36.216ZM102.393 36V19.2H106.449L112.953 35.52V19.2H115.065V36H110.865L104.505 19.8V36H102.393ZM128.901 36.216C124.965 36.216 122.757 33.936 122.757 30.072V19.2H124.917V30.024C124.917 32.52 126.021 34.224 128.901 34.224C131.829 34.224 132.933 32.52 132.933 30.024V19.2H135.093V30.072C135.093 33.936 132.909 36.216 128.901 36.216ZM138.221 36V19.2H144.389C147.509 19.2 149.477 20.856 149.477 23.712C149.477 26.88 147.101 28.344 144.149 28.344H140.333V36H138.221ZM140.333 26.376H144.269C146.069 26.376 147.293 25.752 147.293 23.736C147.293 21.768 146.069 21.12 144.269 21.12H140.333V26.376Z",
    fill: "#F5F5F5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 211.5,
    height: 55.5,
    stroke: "black",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_4112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupbutton);
export default __webpack_public_path__ + "static/media/signupbutton.96116854c19a173f61a22c0c526e0e86.svg";
export { ForwardRef as ReactComponent };